var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2 bg-gray-50 rounded-md shadow-md"},[(_vm.wait)?_c('div',[_c('Spinner',{attrs:{"message":"Loading...","size":6}})],1):_c('div',[_c('ScheduleRequestControlPanel',{attrs:{"showRequestData":_vm.showRequestData,"requestData":_vm.requestData},on:{"runTask":_vm.runTask}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }